import React, {FC} from 'react'
import {Switch, useRouteMatch} from 'react-router'
import {Route} from 'react-router-dom'
import {DirectoryRoot} from './DirectoryRoot'
import {OrgChartDataProvider} from './FullOrgChart/useOrgChartData'
import {OrgChartRoot} from './OrgChartRoot'
import {PrintOrgChart} from './PrintOrgChart'
import {useOrganisationIdStr} from '~/components/useOrganisationIdStr'
import {useQueryDataEditGetFields} from '~/apollo/queries/DataEditField'
import {useQueryDataEditGetValues} from '~/apollo/queries/DataEditValue'
import {useQueryProfileLines} from '~/apollo/queries/ProfileLine'

export type UserlandModal = 'editProfile' | 'groupMessage' | null

export const UserlandRoot: FC = () => {
    const {path} = useRouteMatch()!

    const orgIdStr = useOrganisationIdStr()
    const [fieldsData, dataEditFields] = useQueryDataEditGetFields(orgIdStr)
    const [valuesData, dataEditValues] = useQueryDataEditGetValues(orgIdStr)
    const [linesData, profileLines] = useQueryProfileLines(orgIdStr)
    const data = {
        dataEditFields,
        dataEditValues,
        profileLines,
        error: fieldsData.error || valuesData.error || linesData.error,
        loading: fieldsData.loading || valuesData.loading || linesData.loading,
    }

    return (
        <Switch>
            <Route path={`${path}/print-org-chart`}>
                <OrgChartDataProvider>
                    <PrintOrgChart />
                </OrgChartDataProvider>
            </Route>
            <Route path={`${path}/org-chart`}>
                <OrgChartRoot data={data} />
            </Route>
            <Route default>
                <DirectoryRoot data={data} />
            </Route>
        </Switch>
    )
}
